var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkulabsSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1073_4376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112 0H8C3.58172 0 0 3.58172 0 8V112C0 116.418 3.58172 120 8 120H112C116.418 120 120 116.418 120 112V8C120 3.58172 116.418 0 112 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2587 94.4512V25.5488C32.2587 22.4843 29.7744 20 26.7099 20C23.6454 20 21.1611 22.4843 21.1611 25.5488V94.4512C21.1611 97.5157 23.6454 100 26.7099 100C29.7744 100 32.2587 97.5157 32.2587 94.4512Z",
    fill: "#4AA199"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1445 97.2256V22.7744C52.1445 21.2421 50.9023 20 49.3701 20C47.8378 20 46.5957 21.2421 46.5957 22.7744V97.2256C46.5957 98.7579 47.8378 100 49.3701 100C50.9023 100 52.1445 98.7579 52.1445 97.2256Z",
    fill: "#4AA199"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.327 94.4512V25.5488C68.327 22.4843 65.8428 20 62.7783 20C59.7138 20 57.2295 22.4843 57.2295 25.5488V94.4512C57.2295 97.5157 59.7138 100 62.7783 100C65.8428 100 68.327 97.5157 68.327 94.4512Z",
    fill: "#4AA199"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.122 97.2256V22.7744C83.122 21.2421 81.8799 20 80.3476 20C78.8154 20 77.5732 21.2421 77.5732 22.7744V97.2256C77.5732 98.7579 78.8154 100 80.3476 100C81.8799 100 83.122 98.7579 83.122 97.2256Z",
    fill: "#4AA199"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8378 94.4512V25.5488C98.8378 22.4843 96.3535 20 93.289 20C90.2245 20 87.7402 22.4843 87.7402 25.5488V94.4512C87.7402 97.5157 90.2245 100 93.289 100C96.3535 100 98.8378 97.5157 98.8378 94.4512Z",
    fill: "#4AA199"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1073_4376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkulabsSquare);
export default __webpack_public_path__ + "static/media/skulabs-square.54533b35e4278ccb909141ab34712c42.svg";
export { ForwardRef as ReactComponent };